<app-error-page-layout>
  <div
    class="bg-accent-orange-subtle mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full">
    <i [class]="ICONS.lock" class="text-accent-orange text-4xl"></i>
  </div>

  @if (termsDeclined()) {
    <h1 class="mb-2">{{ 'error_pages.access_denied.title' | translate }}</h1>
    <p class="text-text-secondary mb-8">
      {{ 'error_pages.access_denied.description' | translate }}
    </p>
  } @else {
    <h1 class="mb-2">{{ 'error_pages.access_denied.generic_title' | translate }}</h1>
    <p class="text-text-secondary mb-8">
      {{ 'error_pages.access_denied.generic_description' | translate }}
    </p>
  }

  <button
    type="button"
    class="btn btn-primary btn-lg"
    data-testid="access-denied-sign-in"
    (click)="signInAgain()">
    {{ 'error_pages.access_denied.sign_in_again' | translate }}
  </button>
</app-error-page-layout>
